import { Form, Formik } from "formik";
import { connect } from "react-redux";
import { Modal, Row, Col } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";

import ConsolidationModal from "../../../Inventory/Items/ConfirmationModal/ConsolidationModal";
import CustomInventoryComponent from "../../../../shared/components/inventory/CustomInventoryComponent";
import { addTradeCustomItemValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import {
  EMPTY_STRING,
  inventoryConstants,
  transactionConstants,
} from "../../../../constants";
import {
  systemActions,
  inventoryActions,
  transactionActions,
} from "../../../../redux/actions";
import {
  formatDate,
  calculateOfferPrices,
  isTransactionAllowed,
  handleCashOfferValues,
  handleTradeOfferValues,
  getMarginDropdownValue,
  getTypeOrCategoryObject,
  getCustomProductIfExist,
  getCustomItemInitialValues,
  getAddInventoryPricePayloadObject,
  getAddInventoryRootPayloadPartialObject,
} from "../../../../shared/utility";

const AddTradeCustomItem = (props) => {
  const {
    user,
    outlet,
    inventory,
    transaction,
    currentStore,
    newTradeData,
    tradeDiscount,
    productToEdit,
    addItemInCart,
    handleTradeData,
    customItemModal,
    generateTempSku,
    itemOrganization,
    toggleCustomItemModal,
    isEditCustomItemModal = true,
    isCustomStoreProduct = true,
    getCustomProductsIfExistInInventory,
  } = props;

  const { productTags, inventoryProducts } = inventory;

  const { tempSku } = transaction;

  const formikRef = useRef();
  const isProductEdit = productToEdit?.id ? true : false;
  //-------Reducer
  const { tradeinMargin } = tradeDiscount;
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;

  const [isProductExist, setIsProductExist] = useState(false);
  const [marginObject, setMarginObject] = useState(tradeinMargin?.globalMargin);
  const [ratio, setRatio] = useState(
    tradeinMargin?.globalMargin?.tradeinMarginPercentage /
      tradeinMargin?.globalMargin?.cashMarginPercentage
  );
  const [customProductSelectedTags, setCustomProductSelectedTags] = useState(
    isProductEdit
      ? productToEdit?.tags?.filter(
          (tag) => tag !== inventoryConstants.CUSTOM_ITEM_TAG
        )
      : []
  );

  //-------onselectedtagchange
  const onCustomProductSelectTagsChange = (selectedTags) => {
    const selectedTagList = selectedTags.map((tag) => tag.label);
    setCustomProductSelectedTags(selectedTagList);
  };
  //-------initial values for custom item
  const initialValues = {
    cashOffer: isProductEdit ? productToEdit?.cashOffer : EMPTY_STRING,
    tradeOffer: isProductEdit ? productToEdit?.tradeOffer : EMPTY_STRING,
    ...getCustomItemInitialValues(
      isProductEdit,
      productToEdit,
      customTypes,
      customCategories,
      customSubCategories,
      isEditCustomItemModal
    ),
  };
  //-------handle hide modal
  const handleHideModal = () => {
    toggleCustomItemModal();
  };

  const handleCustomItemSubmit = async (values) => {
    //------- check session is open or not also in use or not or outlet is configured or not
    if (isTransactionAllowed(outlet, user, currentStore)) {
      return;
    }

    const marginObjectToSubmit = getMarginDropdownValue(
      0,
      tradeinMargin,
      getTypeOrCategoryObject(customTypes, values.type)?.productType,
      {
        consoleName: getTypeOrCategoryObject(
          customCategories,
          values.category_name
        )?.name,
        genre: EMPTY_STRING,
      },
      false
    );

    generateTempSku();
    const date_added = formatDate(new Date());
    // const skuNumber = await getSkuNumber();
    const { inStockPrice, quantity, ...otherValues } = values;
    let miscellaneousItem = {
      ...otherValues,
      ...getAddInventoryRootPayloadPartialObject({
        ...values,
        productType: getTypeOrCategoryObject(customTypes, values.productType)
          ?.productType,
      }),
      tags: [
        ...(customProductSelectedTags || []),
        inventoryConstants.CUSTOM_ITEM_TAG,
      ],
      max: 9999,
      imgUrl: isProductEdit ? productToEdit?.imgUrl || EMPTY_STRING : "",
      ratio: ratio,
      genre: "",
      date_added: date_added,
      additionalCheckList: [],
      epid: EMPTY_STRING,
      trackQuantity: values.trackQuantity,
      apiSource: inventoryConstants.CUSTOM_ITEM,
      product_id: inventoryConstants.CUSTOM_ITEM,
      tcgPlayerUrl: EMPTY_STRING,
      sku: isProductEdit
        ? productToEdit.sku
        : [`${inventoryConstants.CUSTOM_ITEM} ${tempSku}`],
      store: { id: currentStore.id, name: currentStore.storeName },
      category_name: getTypeOrCategoryObject(
        customCategories,
        values.category_name
      )?.name,
      subcategory:
        getTypeOrCategoryObject(customSubCategories, values.subcategory)
          ?.name || "",
      price: getAddInventoryPricePayloadObject({
        ...values,
        quantity: values.quantity,
        onlineQuantity: values.onlineQuantity,
        type: values.condition,
      }),
      tradeProductMetaData: {
        isItemLocked: false,
        cashPercentagePerItem: 0,
        tradePercentagePerItem: 0,
        tradeProductType: transactionConstants.CUSTOM_TRADE_PRODUCT,
        tradeInMarginTypeObject: marginObjectToSubmit,
      },
      isSeparateQuantity: values.isSeparateQuantity ?? false,
      isOnlineQuantity: values.isOnlineQuantity ?? false,
    };
    //------Keep an initial State of the Item
    miscellaneousItem = {
      ...miscellaneousItem,
      productInitialState: miscellaneousItem,
    };

    if (isEditCustomItemModal) {
      getCustomProductsIfExistInInventory(currentStore?.id, {}, true);
    }

    if (isProductEdit && isCustomStoreProduct && isEditCustomItemModal) {
      handleTradeData({
        ...newTradeData,
        inventory: newTradeData?.inventory?.map((item) => {
          return item.id === productToEdit?.id
            ? {
                ...productToEdit,
                ...miscellaneousItem,
                productInitialState: productToEdit.productInitialState,
              }
            : item;
        }),
      });
    } else {
      addItemInCart(...[miscellaneousItem]);
    }
    toggleCustomItemModal();
  };

  //------- handle Product Type Change
  const handleTypeChange = (option, setFieldValue, values) => {
    setFieldValue("productType", option.value);
    setFieldValue("condition", EMPTY_STRING);
    setFieldValue("category_name", EMPTY_STRING);
    setFieldValue("subcategory", EMPTY_STRING);

    let tempRes = getMarginDropdownValue(
      0,
      tradeinMargin,
      option.label,
      {
        consoleName: EMPTY_STRING,
        genre: EMPTY_STRING,
      },
      false
    );
    setRatio(
      tempRes.marginObject.tradeinMarginPercentage /
        tempRes.marginObject.cashMarginPercentage
    );
  };

  //------- handle Category Change
  const handleCategoryChange = (option, setFieldValue, values) => {
    setFieldValue("category_name", option.value);
    setFieldValue("subcategory", EMPTY_STRING);
    let tempRes = getMarginDropdownValue(
      0,
      tradeinMargin,
      getTypeOrCategoryObject(customTypes, values.type)?.productType,
      {
        consoleName: option.label,
        genre: EMPTY_STRING,
      },
      false
    );
    setMarginObject(tempRes);
    setRatio(
      tempRes.marginObject.tradeinMarginPercentage /
        tempRes.marginObject.cashMarginPercentage
    );
  };

  //------- handle Sub-Category Change
  const handleSubCategoryChange = (option, setFieldValue, values) => {
    setFieldValue("subcategory", option.value);
    let tempRes = getMarginDropdownValue(
      0,
      tradeinMargin,
      getTypeOrCategoryObject(customTypes, values.type)?.productType,
      {
        consoleName: getTypeOrCategoryObject(
          customCategories,
          values.category_name
        )?.name,
        genre: option.label,
      },
      false
    );
    setMarginObject(tempRes);
    setRatio(
      tempRes.marginObject.tradeinMarginPercentage /
        tempRes.marginObject.cashMarginPercentage
    );
  };

  useEffect(() => {
    //------ calculate ratio between cash offer and trade offer
    //------ tradeOfferPercentage/cashOfferPercentage
    setRatio(
      tradeinMargin?.globalMargin?.tradeinMarginPercentage /
        tradeinMargin?.globalMargin?.cashMarginPercentage
    );
    setMarginObject(tradeinMargin?.globalMargin);
  }, [tradeinMargin]);

  useEffect(() => {
    if (isProductExist) {
      const totalCashOffer = calculateOfferPrices(
        isProductExist.price.unit_sell_price,
        marginObject,
        marginObject.cashMarginPercentage,
        marginObject.tradeinMarginPercentage
      );
      formikRef.current?.setFieldValue("cashOffer", totalCashOffer.cashOffer);
      formikRef.current?.setFieldValue("tradeOffer", totalCashOffer.tradeOffer);
    }
  }, [isProductExist]);

  return (
    <>
      <Modal
        show={customItemModal}
        size="lg"
        onHide={handleHideModal}
        animation={true}
        centered
        backdrop="static"
        className="add-inventory-modal"
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title>
            <span className="add-inventory-modal-header-name">
              {isProductEdit && isEditCustomItemModal
                ? "Edit Trade Custom item"
                : "Trade Custom Item"}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body p-1">
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            onSubmit={handleCustomItemSubmit}
            validate={addTradeCustomItemValidationSchema}
          >
            {({ resetForm, setFieldValue, values }) => {
              if (inventoryProducts?.length) {
                setIsProductExist(
                  getCustomProductIfExist(
                    { ...values, title: values.product_name },
                    customTypes,
                    customCategories,
                    { productsAvailableInInventory: inventoryProducts },
                    customSubCategories,
                    customProductSelectedTags,
                    true
                  )
                );
              }

              return (
                <Form>
                  <Row className="m-0">
                    <CustomInventoryComponent
                      values={values}
                      formikRef={formikRef}
                      productTags={productTags}
                      setFieldValue={setFieldValue}
                      isProductExist={isProductExist}
                      handleHideModal={handleHideModal}
                      isCustomItemTab={true}
                      setIsCustomItemTab={() => {}}
                      customProductSelectedTags={customProductSelectedTags}
                      onCustomProductSelectTagsChange={
                        onCustomProductSelectTagsChange
                      }
                      isTradeCustomItem={true}
                      handleTypeChange={handleTypeChange}
                      handleCategoryChange={handleCategoryChange}
                      handleSubCategoryChange={handleSubCategoryChange}
                      isEditCustomItemModal={isEditCustomItemModal}
                      ratio={ratio}
                      handleCashOfferValues={handleCashOfferValues}
                      handleTradeOfferValues={handleTradeOfferValues}
                      isProductEdit={isProductEdit}
                    />
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
      <ConsolidationModal />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  outlet: state.outlet,
  user: state.authentication.user,
  inventory: state.inventory,
  transaction: state.transaction,
  currentStore: state.store.currentStore,
  itemOrganization: state.itemOrganization,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  generateTempSku: () => dispatch(transactionActions.generateTempSku()),
  getCustomProductsIfExistInInventory: (storeId, data, isEmpty) =>
    dispatch(
      inventoryActions.getCustomProductsIfExistInInventory(
        storeId,
        data,
        isEmpty
      )
    ),
});

//-------Export transaction Component
export default connect(mapStateToProps, mapDispatchToProps)(AddTradeCustomItem);
